import * as React from 'react';
import {UIState} from "data/UIState";
import DashboardData from "data/DashboardData";
import {DateTimeHelpers} from "shared/DateTimeHelpers";

import './NotOpenYet.pcss';
import {observer} from "mobx-react";

export const NotOpenYet = observer(() => {

  if(UIState.settings.PLATFORM_OPEN || UIState.user.isAdmin || !DashboardData.singleSolution) {
    return null;
  }

  if(DashboardData.singleSolution.isSingleSolution) {



    return (
      <div className={"not-open-yet"}>
        <img className="logo" src={DashboardData.singleSolution.solutionLogo} alt={`Logo for ${DashboardData.singleSolution.name}`} />
        <h2>Welcome to your Wellness Concepts dashboard!</h2>
        <p>The {DashboardData.singleSolution.name} will be available on  {DateTimeHelpers.monthDayOrdinal(DashboardData.singleSolution.openDate)}.</p>
      </div>
    )
  } else {
    return (
      <div className={"not-open-yet"}>
        <img className="logo" src={"img/portal_logo.png"} alt={`Portal Logo`} />
        <h2>Welcome to your Wellness Concepts dashboard!</h2>
        <p>The platform will be available on {UIState.settings.PLATFORM_OPEN_DATE}.</p>
      </div>
    )
  }

});

